import { IRegisterValues } from 'FeatureModules/Auth/types/auth.types';
import * as Yup from 'yup';

const registrationSchema = Yup.object().shape({
  email: Yup.string()
    .default('')
    .email('Please enter a valid email')
    .required('This field is required'),
  password: Yup.string()
    .default('')
    .required('This field is required.')
    .min(8, 'Please enter at least 8 characters')
    .matches(/^(?=.*[a-z])/, 'Password must contain at least one lowercase letter.')
    .matches(/^(?=.*[A-Z])/, 'Password must contain at least one uppercase letter.')
    .matches(/^(?=.*\d)/, 'Password must contain at least one number.')
    .matches(
      /^(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])/,
      'Password must contain at least one special character.'
    ),
  confirmPassword: Yup.string()
    .default('')
    .required('This field is required.')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
  firstName: Yup.string().default('').required('This field is required.'),
  lastName: Yup.string().default('').required('This field is required.'),
  companyName: Yup.string().default('').required('This field is required.'),
  industry: Yup.string().default('').required('This field is required.'),
  termsAccepted: Yup.bool()
    .default(false)
    .oneOf([true], 'Please accept the terms and conditions')
    .required('Please accept the terms and conditions'),
}) as Yup.ObjectSchema<IRegisterValues>;

export const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required('This field is required').default(''),
  newPassword: Yup.string()
    .default('')
    .required('This field is required.')
    .min(8, 'Please enter at least 8 characters')
    .notOneOf([Yup.ref('oldPassword')], 'New password must be different from the old password')
    .matches(/^(?=.*[a-z])/, 'Password must contain at least one lowercase letter.')
    .matches(/^(?=.*[A-Z])/, 'Password must contain at least one uppercase letter.')
    .matches(/^(?=.*\d)/, 'Password must contain at least one number.')
    .matches(/[^a-zA-Z0-9\s]/g, 'Password must contain at least one special character.'),
  confirmNewPassword: Yup.string()
    .default('')
    .required('This field is required.')
    .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
}) as Yup.ObjectSchema<IChangePasswordFormValues>;

export interface IChangePasswordFormValues {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export default registrationSchema;
